import { SliceCaseReducers } from '@reduxjs/toolkit'
import {
  ApiResponse,
  createDownloadSlice,
  createOperationSlice,
  GenericOperationState,
} from '@repo/core'
import {
  ConsolidatedPortfolioRequestParams,
  ConsolidatedPortfolioResponse,
} from '@repo/position-types'

const initialState: GenericOperationState<ApiResponse<ConsolidatedPortfolioResponse> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: consolidatedPortfolioActions, reducer: consolidatedPortfolioReducer } =
  createOperationSlice<
    ApiResponse<ConsolidatedPortfolioResponse> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<ConsolidatedPortfolioResponse> | null>>,
    ConsolidatedPortfolioRequestParams
  >({
    name: '@position/master/list/consolidatedPortfolio',
    initialState,
    reducers: {},
  })

export const {
  actions: consolidatedPortfolioDownloadActions,
  reducer: consolidatedPortfolioDownloadReducer,
} = createDownloadSlice<ConsolidatedPortfolioRequestParams | undefined>(
  '@position/master/list/consolidatedPortfolioDownload',
)
